import { Invoice } from 'dashboard/models/invoice';
import Action from 'lib/interfaces/Action';

export type InvoicesActions = Action<InvoicesActionType.SetInvoices, SetInvoicesPayload>;

export enum InvoicesActionType {
  SetInvoices = 'invoices/SET_INVOICES',
}

interface SetInvoicesPayload {
  invoices: Invoice[];
}

export function setInvoices(
  invoices: Invoice[],
): Action<InvoicesActionType.SetInvoices, SetInvoicesPayload> {
  return {
    payload: {
      invoices,
    },
    type: InvoicesActionType.SetInvoices,
  };
}
